import React, { useState } from "react";
import { Element } from "react-scroll";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Home from "./components/Home";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import ZomatoRagChatbot from "./components/pages/ZomatoRagChatbot"; // adjust import path
import WeatherRouter from "./components/pages/WeatherRouter"

export default function App() {
  const [activeSection, setActiveSection] = useState("home");

  return (
    <Router>
      <Routes>
        {/* Only show Nav inside this route */}
        <Route
          path="/"
          element={
            <div>
              <Nav activeSection={activeSection} onSetActive={setActiveSection} />
              <Element name="home"><Home /></Element>
              <Element name="about"><About /></Element>
              <Element name="projects"><Projects /></Element>
              <Element name="contact"><Contact /></Element>
            </div>
          }
        />
        {/* No Nav bar here */}
        <Route path="/zomato-rag" element={<ZomatoRagChatbot />} />
        <Route path="/weather-router" element={<WeatherRouter />}/>
      </Routes>
    </Router>
  );
}
